import React from 'react'
import PropTypes from 'prop-types'

import EmptySection from '../EmptySection'

const WorkplacePolicyEmptyState = ({ toggleEditing, enabledForCurrentState }) => (
  <EmptySection
    svgName="location-pin-flag"
    svgWidth={80}
    buttonAction={() => toggleEditing(true)}
    buttonLabel="Add location and remote preferences"
    hideButton={!enabledForCurrentState}
    theme="primary">
    <p>Listing your preferences about how you want to work and from where helps ensure that the right companies reach out to you.</p>
  </EmptySection>
)

WorkplacePolicyEmptyState.propTypes = {
  toggleEditing: PropTypes.func,
  enabledForCurrentState: PropTypes.bool,
}

export default WorkplacePolicyEmptyState
